// extracted by mini-css-extract-plugin
module.exports = {"xs":"Icon_xs__mGHC2","s":"Icon_s__wsd5Q","m":"Icon_m___LfX_","l":"Icon_l__avcdM","xl":"Icon_xl__6XWzr"};